import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon";
export default function MousePointer(props) {
    return (_jsxs(Icon, { ...props, children: [_jsx("path", { d: "M2.293 2.293a1 1 0 0 1 1.092-.216l16.97 7.07a1 1 0 0 1-.063 1.87l-6.924 2.351-2.351 6.924a1 1 0 0 1-1.87.063l-7.07-16.97a1 1 0 0 1 .216-1.092Zm2.564 2.564 5.118 12.284 1.658-4.883a1 1 0 0 1 .625-.625l4.883-1.658L4.857 4.857Z" }), _jsx("path", { d: "M12.293 12.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414Z" })] }));
}
